module.exports = __webpack_public_path__ + "static/sonnen_charger_moodboard-e5d104db767a0c3e3da4d15fcbc09543.mp4";